import React from 'react';
import { Search, MessageSquare, Bell, Settings, Menu } from 'lucide-react';
import { useUser } from '../../context/UserContext';
import { useNavigate } from 'react-router-dom';

const SellerNavbar = ({ onToggleMobile }) => {
  const { user } = useUser();
  const navigate = useNavigate();

  return (
    <header className="seller-header border-bottom-0 shadow-sm" style={{ height: '80px', padding: '0 2rem' }}>
      <div className="d-flex align-items-center me-4">
        {/* Mobile menu toggle */}
        <button 
          className="btn-icon mobile-toggle me-3 d-lg-none bg-transparent border-0" 
          onClick={onToggleMobile}
        >
          <Menu size={24} />
        </button>
        <div className="d-none d-md-block">
          <h4 className="mb-0 fw-bold text-dark" style={{ fontSize: '1.2rem', letterSpacing: '-0.3px' }}>
            Analysis
          </h4>
          <span className="text-muted" style={{ fontSize: '0.8rem' }}>Let's check your store today</span>
        </div>
      </div>

      <div className="d-flex align-items-center flex-grow-1 justify-content-end gap-3">
        {/* Search Bar */}
        <div className="position-relative d-none d-lg-flex" style={{ width: '300px', marginRight: '2rem' }}>
          <Search size={16} className="position-absolute text-muted" style={{ top: '10px', left: '12px' }} />
          <input 
            type="text" 
            className="form-control border-0 bg-light rounded-3 shadow-none" 
            placeholder="Search Dashboard" 
            style={{ paddingLeft: '36px', fontSize: '0.85rem' }} 
          />
        </div>

        {/* Action Icons */}
        <div className="d-flex align-items-center gap-3">
          <button className="btn-icon bg-transparent border-0 position-relative p-1 text-muted hover-text-primary">
            <span style={{ fontSize: '1.2rem' }}>🇺🇸</span>
          </button>
          
          <button className="btn-icon border-0 position-relative p-2 rounded-circle" style={{ background: 'var(--seller-accent)' }}>
            <MessageSquare size={16} className="text-white" />
            <span className="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle text-white d-flex align-items-center justify-content-center" style={{ width: '14px', height: '14px', fontSize: '8px' }}>2</span>
          </button>
          
          <button className="btn-icon bg-transparent border-0 position-relative p-2 text-muted">
            <Bell size={18} />
          </button>

          <button className="btn-icon bg-transparent border-0 position-relative p-2 text-muted">
            <Settings size={18} />
          </button>
        </div>

        <div className="ms-2 d-flex align-items-center gap-2 cursor-pointer" onClick={() => navigate('/seller/settings')}>
          <div className="d-none d-md-block text-end">
             <div className="fw-bold text-dark text-sm mb-0 lh-1">{user?.storeName || user?.username || 'Seller'}</div>
             <div className="text-muted text-xs">{user?.role === 'admin' ? 'Admin' : 'Store Owner'}</div>
          </div>
          <img 
            src={`https://ui-avatars.com/api/?name=${user?.storeName || user?.username || 'S'}&background=299E60&color=fff`} 
            className="rounded-circle border border-2 border-light shadow-sm" 
            alt="Profile" 
            style={{ width: '40px', height: '40px', objectFit: 'cover' }} 
          />
        </div>
      </div>
    </header>
  );
};

export default SellerNavbar;
